/* eslint-disable angular/controller-name, angular/controller-as, angular/document-service */

var GradeType = {
	UNDEFINED: 0,
	SUM: 1,
	CUSTOM: 2,
};
Object.freeze(GradeType);

angular.
module("digiexam").
controller("ExamGradingController", function ExamGradingController(
	$location,
	$rootScope,
	$routeParams,
	$scope,
	$timeout,

	DX_QUESTION_TYPE,
	dxApi,
	dxEvent,
	ExamRepository,
	examState,
	examStatus,
	focus,
	localStorageService,
	DX_URLS,
	NodeRepository,
	dxSession,
	dxSorting,
	RoleTypeEnum,

	DX_CAP_SETTINGS,
	DX_GRADING_TYPES,
	DX_WORD_GAP_MODE,
	dxDebounce,
	dxDialog,
	dxLocalize,

	DxAnnotationMessageService,
	dxAngularConstantHelper
) {
	"use strict";

	var localStorageNamespace = "exam.grading.";
	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	$scope.reqs = {
		exam: false,
		grades: false,
	};

	$scope.examState = examState;
	$scope.examStatus = examStatus;
	$scope.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	$scope.DX_GRADING_TYPES = DX_GRADING_TYPES;
	$scope.DX_WORD_GAP_MODE = DX_WORD_GAP_MODE.STATIC;
	$scope.capText = [dxLocalize.get("WordsNoCap"), dxLocalize.get("WordsSoftCap"), dxLocalize.get("WordsHardCap")];
	$scope.commentFocusId = "grading-feedback-comment-";
	$scope.scoreFocusId = "grading-feedback-score-";
	$scope.saving = false;
	$scope.saveSuccess = false;
	$scope.saveError = false;
	$scope.lastSavedTime = null;
	$scope.fullscreen = false;
	$scope.fullscreenTransitionClass = "";
	$scope.isAnimating = false;
	$scope.offsetHeight = {};
	$scope.ORDER_PREFERENCE_KEY = "orderStudentsBy";
	$scope.hasTeacherRole = dxSession.getRole().roleType !== RoleTypeEnum.STUDENT;

	// The queue unconditionally tries to submit the first grade in the queue
	// to the server. The first item in the queue is removed if the save succeeds
	$scope.gradeQueue = [];
	$scope.queuePulseTimeout = null;
	$scope.enqueueDebounces = {};
	//data added to useTotalSum to have always updated value for checkbox in the frontend
	$scope.data = {
		useTotalSum: true,
	  };
	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		$scope.node = node;
	}

	$scope.enqueueGradeSave = function enqueueGradeSave(grade, keepFinal, isAnnotations) {
		var gradeCopy = angular.copy(grade);

		if (!$scope.enqueueDebounces[gradeCopy.cacheId]) {
			$scope.enqueueDebounces[gradeCopy.cacheId] = dxDebounce();
		}

		$scope.enqueueDebounces[gradeCopy.cacheId].debounce(500).then(function onGradeDebounce() {
			$scope.gradeQueue.push(gradeCopy);
		}, angular.noop);

		if (isAnnotations && $scope.selectedStudent.finalGrade.finalGradeType === 2) {
			$scope.enqueueGradeSave($scope.selectedStudent.finalGrade);
		}

		// Trigger recalculation of the total sum
		// If it's a grade for a question that has been updated
		if (gradeCopy.questionId && !keepFinal && !isAnnotations) {
			dropCustomGrade();
			recalcTotalSum();
		}
	};

	$scope.queuePulse = function onQueuePulse() {
		if ($scope.gradeQueue.length > 0) {
			$scope.saving = true;
			var grade = $scope.gradeQueue[0];
			var promise = null;

			if (grade.questionId) {
				promise = dxApi.legacy.grades.post(grade);
			} else {
				promise = dxApi.legacy.finalGrades.post(grade);
			}

			promise.then(function onGradeSaveSuccess() {
				$scope.gradeQueue.shift();
				$scope.saveGradeDone(true, true);
				$scope.queuePulse();
			}, function onGradeSaveError() {
				$scope.queuePulseTimeout = $timeout($scope.queuePulse, 2000);
				$scope.saveGradeDone(false, true);
			});
		} else {
			$scope.queuePulseTimeout = $timeout($scope.queuePulse, 200);
		}
	};

	$scope.queuePulse();


	$scope.$on("Annotations:Save", function saveAnnotations() {
		$scope.enqueueGradeSave($scope.selectedAnswer.grade, true, true);
	});

	$scope.$on("$destroy", function scopeDestroyed() {
		$timeout.cancel($scope.queuePulseTimeout);
	});

	$scope.saveAndClose = function saveAndClose() {
		$location.path(DX_URLS.get("examGrades", $scope.exam));

		// Ask backend to recalculate hand-in counters.
		dxApi.v1.exams.recalculate(parseInt($routeParams.id, 10));
	};

	$scope.saveGradeDone = function saveGradeDone(success, autoSaved) {
		var date = new Date();

		$scope.saveSuccess = success;
		$scope.saveError = !success;
		$scope.autoSaved = !!autoSaved;
		$scope.lastSavedTime = sprintf("%02d:%02d:%02d", date.getHours(), date.getMinutes(), date.getSeconds()); // eslint-disable-line no-undef
		$scope.saving = false;
	};

	// Changes to the state will be saved to localStorage and restored when the controller is loaded.
	$scope.state = {
		selectedStudentId: null, // int
		selectedQuestionId: null, // int
		isFinalGradeSelected: false,
		showQuestionDetails: true,
	};

	// tempState will be reset each time the controller is loaded.
	$scope.tempState = {
		filterHideGradedStudents: false,
	};

	$scope.selectedStudent = null;
	$scope.selectedStudentIndex = null;
	$scope.selectedQuestion = null;
	$scope.selectedQuestionIndex = null;
	$scope.selectedAnswer = null;
	$scope.skipNextStateSave = true;

	$scope.$watch("state", function watchState() {
		if ($scope.state && !$scope.skipNextStateSave) {
			$scope.saveState();
		}

		$scope.skipNextStateSave = false;
	}, true);

	// Reduce function - return sum of all grade score
	function scoreSum(sum, answer) {
		return sum + answer.grade.score;
	}

	// .every function - return if score is set on all grades.
	// The grade.grade is the value that is set on exams using grading matrices.
	function gradeScoreSet(answer) {
		return (answer.grade.score || answer.grade.score === 0 || answer.grade.grade !== "");
	}

	function dropCustomGrade() {
		if (!$scope.selectedStudent || $scope.selectedStudent.finalGrade.finalGradeType !== GradeType.CUSTOM || !$scope.exam.hasFinalGradeAccess) {
			return;
		}

		$scope.selectedStudent.finalGrade.grade = "";
		$scope.enqueueGradeSave($scope.selectedStudent.finalGrade);
	}

	function recalcTotalSum(forceUpdate) {
		if (!$scope.selectedStudent || $scope.selectedStudent.finalGrade.finalGradeType === GradeType.CUSTOM || !$scope.exam.hasFinalGradeAccess) {
			return false;
		}

		var allScoreSet = $scope.selectedStudent.answers.every(gradeScoreSet);
		var initialGradeValue = $scope.selectedStudent.finalGrade.grade;

		if (allScoreSet) {
			var calculatedSum = $scope.selectedStudent.answers.reduce(scoreSum, 0);
			$scope.selectedStudent.finalGrade.grade = calculatedSum + "";
		} else {
			$scope.selectedStudent.finalGrade.grade = "";
		}

		if (
			initialGradeValue !== $scope.selectedStudent.finalGrade.grade ||
			forceUpdate
		) {
			$scope.enqueueGradeSave($scope.selectedStudent.finalGrade);
		}

		return true;
	}

	$scope.useTotalSumChanged = function useTotalSumChanged() {
		$scope.selectedStudent.finalGrade.grade = "";

		if ($scope.selectedStudent.finalGrade.finalGradeType === GradeType.CUSTOM) {
			setFinalGradeType(GradeType.SUM);
			recalcTotalSum(true);
		} else {
			setFinalGradeType(GradeType.CUSTOM);
			focus($scope.scoreFocusId + "final");
			$scope.enqueueGradeSave($scope.selectedStudent.finalGrade);
		}
	};

	function setFinalGradeType(gradeType) {
		$scope.selectedStudent.finalGrade.finalGradeType = gradeType;
		updateUseTotalSum();
	}

	function updateUseTotalSum() {
		$scope.data.useTotalSum = $scope.selectedStudent.finalGrade.finalGradeType === GradeType.SUM;
	}

	function getUngradedStudents(students) {
		return students.filter(function filterUngraded(student) {
			return !student.answers.every(gradeScoreSet);
		});
	}

	$scope.$watch("tempState.filterHideGradedStudents", function watchTempStateFilterHideGradedStudents() {
		if (!($scope.reqs.exam && $scope.reqs.grades)) {
			return;
		}

		if ($scope.tempState.filterHideGradedStudents) {
			$scope.students = getUngradedStudents($scope.studentsWritingDigitally);
		} else {
			$scope.students = $scope.studentsWritingDigitally;
		}

		$scope.sortStudents($scope.getPreference($scope.ORDER_PREFERENCE_KEY));
		var student = $scope.getStudentById($scope.state.selectedStudentId);
		$scope.selectStudent(student || $scope.getStudentByIndex(0));
	});

	$scope.isGradingType = function isGradingType(type) {
		return $scope.exam && $scope.exam.gradingType === type;
	};

	$scope.saveState = function saveState() {
		var key = localStorageNamespace + $scope.exam.id;
		localStorageService.remove(key);
		return localStorageService.add(key, $scope.state);
	};

	$scope.savePreference = function savePreference(name, value) {
		var key = localStorageNamespace + "preferences";
		var savedPreferences = localStorageService.get(key) || {};
		savedPreferences[name] = value;
		localStorageService.remove(key);
		return localStorageService.add(key, savedPreferences);
	};

	$scope.getPreference = function getPreference(name) {
		var key = localStorageNamespace + "preferences";
		var savedPreferences = localStorageService.get(key) || {};
		return savedPreferences[name];
	};

	$scope.restoreState = function restoreState(state) {
		if (!state) {
			return;
		}

		var keys = Object.keys($scope.state);
		keys.forEach(function forEach(key) {
			if (state[key] != null) { // eslint-disable-line eqeqeq, no-eq-null
				$scope.state[key] = state[key];
			}
		});
	};

	$scope.loadExam = function loadExam() {
		var examId = parseInt($routeParams.id, 10);

		ExamRepository.load(examId).then(function success(res) {
			$scope.reqs.exam = true;
			var savedState = localStorageService.get(localStorageNamespace + examId) || {};

			$scope.restoreState(savedState);
			$scope.exam = res;
			$scope.gradingMatrix = $scope.exam.gradingMatrix;

			$scope.exam.getGrades().then(function getGradesSuccess() {
				$scope.studentsWritingDigitally = $scope.exam.students.filter(function writingDigitally(s) {
					return s.writingDigitally;
				});

				$scope.students = $scope.studentsWritingDigitally;

				var student = $scope.getStudentById(savedState.selectedStudentId);
				$scope.selectStudent(student || $scope.getStudentByIndex(0));
				$scope.questions = $scope.exam.questions;

				if (savedState.isFinalGradeSelected) {
					$scope.selectFinalGrade();
				} else if (typeof savedState.selectedQuestionId === "number") {
					$scope.selectQuestionById(savedState.selectedQuestionId);
				} else if ($scope.selectedStudent.isFinalGradeSet()) {
					$scope.selectFinalGrade();
				} else {
					$scope.selectQuestionByIndex(0);
				}

				$scope.reqs.grades = true;
			});

			if ($scope.exam.gradingType === DX_GRADING_TYPES.FORMATIVE) {
				dxEvent.create(DX_EVENT_NAME.PageviewGradingFormativeExam, [{key: "examId", value: examId}]);
			} else {
				dxEvent.create(DX_EVENT_NAME.PageviewGradingSummativeExam, [{key: "examId", value: examId}]);
			}
		});
	};

	$scope.selectStudent = function selectStudent(student) {
		if (!student) {
			return;
		}

		// Always update the selected index because we might filter students
		// and keep the same student selected.
		$scope.selectedStudentIndex = $scope.students.indexOf(student);

		if ($scope.selectedStudent && $scope.selectedStudent.id === student.id) {
			return;
		}

		$scope.selectedStudent = student;
		$scope.state.selectedStudentId = student.id;
		$scope.selectAnswerByIndex($scope.selectedQuestionIndex);
		// TODO(kenneth): Part of the studentlibrary-controller, move them there
		$scope.searchResults = [];
		$scope.searchString = "";

		if (student.finalGrade.finalGradeType === GradeType.UNDEFINED && student.finalGrade.grade) {
			var calculatedSum = student.answers.reduce(scoreSum, 0);
			var allScoreSet = student.answers.every(gradeScoreSet);
			if (parseFloat(student.finalGrade.grade) === calculatedSum &&
				allScoreSet &&
				$scope.exam.gradingType === DX_GRADING_TYPES.SCORE
			) {
				setFinalGradeType(GradeType.SUM);
			} else {
				setFinalGradeType(GradeType.CUSTOM);
			}
		}

		if (student.finalGrade.finalGradeType !== GradeType.CUSTOM &&
			$scope.exam.gradingType === DX_GRADING_TYPES.FORMATIVE
		) {
			setFinalGradeType(GradeType.CUSTOM);
		}

		if ((student.finalGrade.finalGradeType === GradeType.UNDEFINED ||
			student.finalGrade.finalGradeType === GradeType.SUM) &&
			$scope.exam.gradingType === DX_GRADING_TYPES.SCORE
		) {
			setFinalGradeType(GradeType.SUM);
			recalcTotalSum(true);
		}

		updateUseTotalSum();

		return student; // eslint-disable-line consistent-return
	};

	$scope.getStudentByIndex = function getStudentByIndex(index) {
		return $scope.students[index];
	};

	$scope.getStudentById = function getStudentById(id) {
		return $scope.students.filter(function filter(student) {
			return student.id === id;
		})[0];
	};

	$scope.sortStudents = function sortStudents(orderStudentsBy) {
		$scope.students = dxSorting.studentSort($scope.students, orderStudentsBy);
		$scope.selectedStudentIndex = $scope.students.indexOf($scope.selectedStudent);
	};

	$scope.selectQuestion = function selectQuestion(question) {
		/* TODO: Suggested refactor
		 var ref = $scope.selectedQuestion;
		 var questionIdSet = !!question && !!question.id;
		 var selectedQuestionIdSet = !!ref && !!ref.id;
		 if ((!questionIdSet && !selectedQuestionIdSet) || (selectedQuestionIdSet && question.id === ref.id)) {
		 	return;
		 }
		*/
		var ref;
		if (!question || (question.id === ((ref = $scope.selectedQuestion) != null ? ref.id : void 0))) { // eslint-disable-line eqeqeq, no-void, no-eq-null, no-cond-assign, no-negated-condition
			return;
		}

		/* TODO: Suggested refactor
		 ref = document.activeElement;
		 vad focusOn = !!ref ? ref.getAttribute("focus-on") : null;
		*/
		var ref1;
		var focusOn = (ref1 = document.activeElement) != null ? ref1.getAttribute("focus-on") : void 0; // eslint-disable-line eqeqeq, no-void, no-eq-null, no-cond-assign, no-negated-condition, no-undef
		var index = $scope.questions.indexOf(question);

		$scope.state.isFinalGradeSelected = false;
		$scope.selectedQuestion = question;
		$scope.selectedQuestionIndex = index;
		$scope.state.selectedQuestionId = question.id;
		$scope.selectAnswerByIndex(index);

		if (focusOn) {
			if (focusOn.indexOf($scope.commentFocusId) === 0) {
				return focus($scope.commentFocusId + "question"); // eslint-disable-line consistent-return
			} else if (focusOn.indexOf($scope.scoreFocusId) === 0) {
				return focus($scope.scoreFocusId + index); // eslint-disable-line consistent-return
			}
		}
	};

	$scope.selectQuestionByIndex = function selectQuestionByIndex(index) {
		return $scope.selectQuestion($scope.questions[index]);
	};

	$scope.selectQuestionById = function selectQuestionById(id) {
		return $scope.selectQuestion($scope.questions.filter(function filter(question) {
			return question.id === id;
		})[0]);
	};

	$scope.selectAnswer = function selectAnswer(answer) {
		if (!answer || answer === $scope.selectedAnswer) {
			return;
		}

		$scope.selectedAnswer = answer;
		$scope.gradeInputDisabled = $scope.isGradeInputDisabled();
	};

	$scope.selectAnswerByIndex = function selectAnswerByIndex(index) {
		return $scope.selectAnswer($scope.selectedStudent.answers[index]);
	};

	$scope.selectFinalGrade = function selectFinalGrade() {
		if (!$scope.exam.hasFinalGradeAccess) {
			return;
		}

		/* TODO: Suggested refactor
		 var ref = document.activeElement;
		 var focusOn = !!ref ? ref.getAttribute("focus-on") : null;
		*/
		var ref;
		var focusOn = (ref = document.activeElement) != null ? ref.getAttribute("focus-on") : void 0; // eslint-disable-line eqeqeq, no-void, no-eq-null, no-cond-assign, no-negated-condition, no-undef

		$scope.state.isFinalGradeSelected = true;
		$scope.selectedQuestion = null;
		$scope.selectedQuestionIndex = null;
		$scope.state.selectedQuestionId = null;

		if (focusOn) {
			if (focusOn.indexOf($scope.commentFocusId) === 0) {
				return focus($scope.commentFocusId + "final"); // eslint-disable-line consistent-return
			} else if (focusOn.indexOf($scope.scoreFocusId) === 0) {
				return focus($scope.scoreFocusId + "final"); // eslint-disable-line consistent-return
			}
		}
	};

	$scope.getStudentName = function getStudentName(student, firstNameOnly) {
		if ($scope.exam.anonymous) {
			return student.getName(false);
		}

		return student.getName(firstNameOnly);
	};

	$scope.toGenetiveCase = function toGenetiveCase(str) {
		if (!str || typeof str !== "string" || dxLocalize.getLanguage() === "fi") {
			return str;
		}

		var lastChar = str[str.length - 1].toLowerCase();

		if (dxLocalize.getLanguage() === "sv") {
			return str + (["s", "x", "z"].indexOf(lastChar) > -1 ? "" : "s");
		}

		return str + (lastChar === "s" ? "'" : "'s");
	};

	$scope.offlineFileName = function offlineFileName() {
		if (!$scope.exam || !$scope.selectedStudent) {
			return "";
		}

		return "{0}-{1}.dxr".format($scope.exam.id, $scope.selectedStudent.code);
	};

	$scope.toggleQuestionDetails = function toggleQuestionDetails() {
		$scope.state.showQuestionDetails = !$scope.state.showQuestionDetails;
	};

	$scope.selectedAnswerHasBadCap = function selectedAnswerHasBadCap() {
		if ($scope.selectedQuestion.capSetting === DX_CAP_SETTINGS.NONE) {
			return;
		}

		return $scope.selectedAnswer.wordCount() > $scope.selectedQuestion.capValue; // eslint-disable-line consistent-return
	};

	$scope.isGradeInputDisabled = function isGradeInputDisabled() {
		return $scope.exam.publishedParts > 0 || $scope.selectedStudent.state !== examState.FINAL;
	};

	$scope.getGradedString = function getGradedString(question, answer) {
		if (answer === void 0) { // eslint-disable-line no-void
			return;
		}

		var str = "";
		if (!answer.hasAnswer()) {
			str += dxLocalize.get("NotAnswered") + " - ";
		}

		if (!answer.isGraded()) {
			str += dxLocalize.get("NotGraded");
		} else if ($scope.exam.gradingType === DX_GRADING_TYPES.SCORE) {
			var score = answer.grade.score;
			if (typeof score === "number") {
				if (question.maxScore > 0) {
					str += dxLocalize.get("XOfY", score, question.maxScore);
				} else {
					str += score;
				}
			}
		} else if ($scope.exam.gradingType === DX_GRADING_TYPES.FORMATIVE) {
			str += answer.grade.grade;
		}

		return str; // eslint-disable-line consistent-return
	};

	$scope.unsetAbilityGrade = function unsetAbilityGrade(abilityIndex) {
		$scope.selectedAnswer.grade.abilityGrades[abilityIndex] = -1;
		$scope.enqueueGradeSave($scope.selectedAnswer.grade);
	};

	$scope.getMatrixGradeTitle = function getMatrixGradeTitle(gradeId) {
		var filtered = $scope.exam.gradingMatrix.grades.filter(function filter(grade) {
			return grade.id === gradeId;
		});

		if (filtered.length) {
			return filtered[0].title;
		}

		return "";
	};

	$scope.previewGradingMatrix = function previewGradingMatrix() {
		var popupScope = $rootScope.$new();
		popupScope.matrix = this.gradingMatrix;

		dxDialog.show({
			templateUrl: "/partials/popups/view-grading-matrix.html",
			$scope: popupScope,
		});
	};

	$scope.search = function search(query) {
		$scope.searchResults = [];

		if (!query) {
			return;
		}

		query = query.toLowerCase(); // eslint-disable-line no-param-reassign

		$scope.searchResults = $scope.students.filter(function filter(student) { // eslint-disable-line consistent-return
			if (student.name && (!$scope.selectedStudent || student.id !== $scope.selectedStudent.id)) {
				if ($scope.exam.anonymous) {
					return student.name.toLowerCase().indexOf(query) !== -1;
				} else if (student.code) {
					return student.name.toLowerCase().indexOf(query) !== -1 || student.code.toLowerCase().indexOf(query) !== -1;
				}
				return student.name.toLowerCase().indexOf(query) !== -1;
			}
		});
	};

	$scope.toggleFullscreen = function toggleFullscreen() {
		if (!$scope.isAnimating) {
			$scope.isAnimating = true;
			$scope.fullscreenTransitionClass = "fullscreenTransition";
			// Timeout is used to wait for a digest cycle to finish. 100ms is an arbitrarily value.
			$timeout(function timeoutCallback() {
				$scope.fullscreen = !$scope.fullscreen;

				// Timeout is used to wait for the animation to finish. 500ms is the same value as animation time.
				$timeout(function timeoutCallback2() {
					$scope.fullscreenTransitionClass = "";
					$scope.isAnimating = false;
				}, 500);
			}, 100);
		}
	};

	// Calculate the style for the student library.
	// translate3d is used to hardware accelerated the animation for the student library.
	$scope.getStudentlibraryStyle = function getStudentlibraryStyle() {
		var translateValue = 0;
		if ($scope.fullscreen) {
			translateValue = 360;
		}

		return {
			top: $scope.offsetHeight.headerHeight + "px",
			"transform": "translate3d(" + translateValue + "px, 0, 0)", // eslint-disable-line quote-props
		};
	};

	// Calculate the style for the content div.
	// Can't be hardware accelerated because it is only resized.
	$scope.getContentStyle = function getContentStyle() {
		var topValue = $scope.offsetHeight.headerHeight;
		var bottomValue = $scope.offsetHeight.commentScoreHeight;
		var rightValue = 400;

		if ($scope.fullscreen) {
			topValue = $scope.offsetHeight.headerHeight;
			bottomValue = 40;
			rightValue = 40;
		}

		return {
			bottom: bottomValue + "px",
			right: rightValue + "px",
			top: topValue + "px",
		};
	};

	// Calculate the style for the comment score.
	// translate3d is used to hardware accelerated the animation as much as possible.
	// But because the comment score is resized when the student library is animating, it has to render anyways.
	$scope.getCommentScoreStyle = function getCommentScoreStyle() {
		var translateValue = 0;
		var rightValue = 400;

		if ($scope.fullscreen) {
			translateValue = $scope.offsetHeight.commentScoreHeight - 40;
			rightValue = 40;
		}
		return {
			"transform": "translate3d(0, " + translateValue + "px, 0)", // eslint-disable-line quote-props
			right: rightValue + "px",
		};
	};

	$scope.removeAnnotation = function removeAnnotation(annotation) {
		DxAnnotationMessageService.deleteAnnotation(annotation);
	};

	$scope.highlightAnnotation = function highlightAnnotation(annotation, add) {
		DxAnnotationMessageService.highlightAnnotation({annotationCacheId: annotation.cacheId, add: add});
	};

	// Init
	$scope.loadExam();
});
